










import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

@Component({})
export default class Space extends Vue {
  /** horizontal | vertical */
  @Prop({ default: 'horizontal' }) direction: string;
  /** small | middle | large | number */
  @Prop({ default: 'small' }) size: string | number;

  @Watch('direction')
  watchDirection() {
    this.toRender();
  }
  @Watch('size')
  watchSize() {
    this.toRender();
  }

  mounted() {
    this.toRender();
  }
  toRender() {
    const doms = (this.$refs.space as any).children;
    let n = 8;
    if (typeof this.size === 'string') {
      switch (this.size) {
        case 'middle':
          n = 2 * n;
          break;
        case 'large':
          n = 3 * n;
          break;
        default:
          break;
      }
    }
    if (typeof this.size === 'number') {
      n = this.size;
    }
    for (let i = 0; i < doms.length; i++) {
      if (i === 0) {
        continue;
      } else {
        if (this.direction === 'horizontal') {
          doms[i].style.marginLeft = n + 'px';
        }
        if (this.direction === 'vertical') {
          doms[i].style.marginTop = n + 'px';
        }
      }
    }
  }
}
